import * as Types from '../constants/Types';

export const getPayAtHotel = (filters) => ({ type: Types.GET_PAY_AT_HOTEL_ACTION, filters });
export const setPayAtHotel = (payAtHotel) => ({ type: Types.GET_PAY_AT_HOTEL_SUCCESS, payAtHotel });

export const getProfileTypes = () => ({ type: Types.GET_PROFILE_TYPE_ACTION });
export const setProfileTypes = (profileTypes) => ({ type: Types.GET_PROFILE_TYPE_SUCCESS, profileTypes });

export const updatePayAtHotel = (payAtHotel) => ({ type: Types.PAY_AT_HOTEL_UPDATE_ACTION, payAtHotel });